/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useEffect, useState } from 'react';
import { WebSocketManager } from 'src/utils/websocket';

interface WebSocketContextType {
  socket: WebSocket | null;
  isConnected: boolean;
  manager: WebSocketManager | null;
  hasStartedChatting: boolean;
  setHasStartedChatting: (value: boolean) => void;
}

export const WebSocketContext = createContext<WebSocketContextType>({
  socket: null,
  isConnected: false,
  manager: null,
  hasStartedChatting: false,
  setHasStartedChatting: () => {},
});

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const [manager, setManager] = useState<WebSocketManager | null>(null);
  const [hasStartedChatting, setHasStartedChatting] = useState(false);

  useEffect(() => {
    const wsManager = new WebSocketManager({
      onOpen: () => {
        setIsConnected(true);
        setSocket(wsManager.socket);
      },
      onClose: () => {
        setIsConnected(false);
        setSocket(null);
      },
    });

    setManager(wsManager);
    wsManager.connect();

    return () => {
      wsManager.close();
    };
  }, []);

  return (
    <WebSocketContext.Provider
      value={{
        socket,
        isConnected,
        manager,
        hasStartedChatting,
        setHasStartedChatting,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};
